import React from 'react';
import moment from 'moment';
import { InplaceField } from '@aha-app/react-in-place';
import classNames from 'classnames';

const DEFAULT_PLACEHOLDERS = ['Start on', 'Due on'];

// this comes from react-in-place
// https://github.com/aha-app/react-in-place/blob/master/src/lib/DateInput.js
// To keep our date formats in sync any changes in formatting should be made there too
// Also, if we are using this code elsewhere we should look at exporting/importing
// the original version from there
function normalizeDateFormat(dateFormat) {
  dateFormat = dateFormat || 'MM-DD-YYYY';
  return dateFormat
    .replace('%d', 'DD')
    .replace('%-d', 'D')
    .replace('%-m', 'M')
    .replace('%m', 'MM')
    .replace('%Y', 'YYYY');
}

const DateRange = ({ editable, value, variant, ...props }) => {
  const getFormattedDate = dateValue => {
    if (!dateValue) return null;

    dateValue = moment(dateValue);
    return dateValue.format(normalizeDateFormat(props.dateFormat));
  };

  if (editable) {
    if (Array.isArray(value)) {
      value = value.map(v => (v ? moment(v) : v));
    }
    return (
      <InplaceField
        {...props}
        tabIndex='1'
        type={variant || 'date_range'}
        value={value}
      />
    );
  } else {
    const [startPlaceholder, endPlaceholder] =
      props.nil || DEFAULT_PLACEHOLDERS;

    return (
      <div className='react-in-place__date_range_wrapper'>
        <div
          className={classNames(
            'react-in-place__date_range react-in-place react-in-place--block react-in-place__placeholder react-in-place--disabled',
            { 'react-in-place--empty': !value[0] }
          )}
        >
          {getFormattedDate(value[0]) || startPlaceholder}
        </div>
        <span className='react-in-place__date_range_spacer'> — </span>
        <div
          className={classNames(
            'react-in-place__date_range react-in-place react-in-place--block react-in-place__placeholder react-in-place--disabled',
            { 'react-in-place--empty': !value[1] }
          )}
        >
          {getFormattedDate(value[1]) || endPlaceholder}
        </div>
      </div>
    );
  }
};

export default DateRange;
